import {
  AfterViewChecked,
  AfterViewInit,
  Directive,
  DoCheck,
  ElementRef,
  HostBinding,
  Input, NgModule,
  OnInit
} from '@angular/core';
import {Observable, Subscription, timer} from 'rxjs';
import {DefaultSmoothlyImageLoader, SmoothlyImageLoader} from './loader/smoothly-image-loader';
import {CommonModule} from '@angular/common';

@Directive({
  selector: '[smoothly]'
})
export class SmoothlyImageDirective implements OnInit, AfterViewChecked {
  @Input() step = '1s';
  @Input() loader: SmoothlyImageLoader = new DefaultSmoothlyImageLoader();
  private imageUrl;

  constructor(private element: ElementRef<HTMLDivElement>) {
  }

  ngAfterViewChecked(): void {
    const currentImage = this.element.nativeElement.style.backgroundImage;
    if (this.imageUrl !== currentImage && currentImage !== 'unset') {
      this.doLoadImage();
    }
  }

  ngOnInit(): void {
    this.doLoadImage();
  }

  private doLoadImage() {
    this.imageUrl = this.element.nativeElement.style.backgroundImage;
    this.element.nativeElement.style.opacity = '0';
    this.element.nativeElement.style.backgroundImage = 'unset';
    this.element.nativeElement.style.backgroundColor = 'transparent';
    this.loader.load(this.imageUrl).then(base64 => {
      this.imageUrl = this.element.nativeElement.style.backgroundImage = `url("data:image/png;base64,${base64}")`;
      this.element.nativeElement.style.transition = `opacity ${this.step} ease-in-out`;
      this.element.nativeElement.style.opacity = '1';
    });
  }
}

@NgModule({
  declarations: [SmoothlyImageDirective],
  exports: [SmoothlyImageDirective],
  imports: [
    CommonModule
  ]
})
export class SmoothlyImageModule { }
